import HackathonActivity from './HackathonActivity.jsx';

export default HackathonActivity;
